// Lista compartida de giros / sectores empresariales para Beeznz Work
export const INDUSTRIES: string[] = [
  'Tecnología e Informática',
  'Telecomunicaciones',
  'Software y Desarrollo',
  'Comercio y Retail',
  'Comercio Electrónico',
  'Manufactura e Industria',
  'Automotriz',
  'Construcción e Inmobiliaria',
  'Arquitectura e Ingeniería',
  'Salud y Servicios Médicos',
  'Farmacéutica',
  'Educación y Capacitación',
  'Finanzas y Banca',
  'Seguros',
  'Contabilidad y Auditoría',
  'Consultoría y Asesoría',
  'Recursos Humanos',
  'Legal y Jurídico',
  'Marketing y Publicidad',
  'Medios y Comunicación',
  'Diseño y Creatividad',
  'Turismo y Hotelería',
  'Restaurantes y Alimentos',
  'Logística y Transporte',
  'Importación y Exportación',
  'Energía y Petróleo',
  'Energías Renovables',
  'Agricultura y Ganadería',
  'Minería',
  'Textil y Moda',
  'Belleza y Cuidado Personal',
  'Deportes y Recreación',
  'Entretenimiento y Espectáculos',
  'Seguridad Privada',
  'Limpieza y Mantenimiento',
  'Bienes Raíces',
  'Gobierno y Sector Público',
  'Organizaciones sin Fines de Lucro',
  'Investigación y Ciencia',
  'Servicios Profesionales',
  'Otro',
]
